
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PluginService, AlertService } from '../../../services';
import { PoolService, LookupService } from '../../../services/models';
import { BaseEditComponent } from '../../base/base.edit.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PublishDialogComponent } from '../../product.management/publishdialog/publish-dialog.component';

@Component({
    templateUrl: './pools.edit.component.html',
    styleUrls: ['./pools.edit.component.less'], 
    selector: 'pools-edit'
})

export class PoolsEditComponent extends BaseEditComponent implements OnInit {

    poolForm: FormGroup;
    record: any = null;
    pool_styles:any[] = [];
    builders: any[] = [];
    zones: any[] = [];
    products_lookup_endpoint: string = "products";
    @Input() id: any = null;
    @Output() close = new EventEmitter();
    draftPages: any = {};

    constructor(
        private router: Router,
        private poolService: PoolService,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
        protected pluginService: PluginService,
        protected alertService: AlertService,
        public dialog: MatDialog,
        
    ) { 
        super(pluginService);
    }

    ngOnInit() {
        this.poolForm = this.formBuilder.group({
            name: ['', Validators.required],
            slug: ['', Validators.compose([Validators.required])],
            pool_style_id: ['', Validators.required],
            order: [''],
            enabled: [''],
            featured: [''],
            blurb: [''],
            description: [''],
            location: [''],
            construction: [''],
            length: [''],
            width: [''],
            min_depth: [''],
            max_depth: [''],
            builder_id: [''],
            meta_title: [''],
            meta_description: [''],
            meta_image: [''],
            main_image_url: [''],
            list_image_url: [''],
            related_products: [],
            zone: [''],
            page_start_date: [''],
            page_end_date: [''],
        });

        this.lookupService.getAll("pool_styles")
            .subscribe(
                data => {
                    this.pool_styles = data.data;
                },
                error => {
                    this.handleError(error, this.poolForm);
                });
        
        this.lookupService.getAll("builders")
                .subscribe(
                    data => {
                        this.builders = data.data;
                    },
                    error => {
                        this.handleError(error, this.poolForm);
                    });
        
        this.lookupService.getAll("zones")
                .subscribe(
                    data => {
                        this.zones = data.data;
                    },
                    error => {
                        this.handleError(error, this.poolForm);
                    });

        if (this.id != 'new') {
            this.poolService.getRecord(this.id)
                .subscribe(
                    data => {
                        this.record = data.data;
                        this.draftPages = this.record.draft_pages;
                    },
                    error => {
                        this.record = {};
                        this.handleError(error, this.poolForm);
                    });
        } else {
            this.record = {
                "related_products": {"data": []}
            };
        }
    }

    cancel() {
        this.close.emit();
    }

    reset(value) {
        if(value == 'page_start_date')
        this.record.page_start_date = '';
        else
        if(value == 'page_end_date')
        this.record.page_end_date = '';
      }

    save() {
        let product_ids =  this.record.related_products;
        
        this.record = this.poolForm.value;
        this.record.id = this.id;
        this.record.related_products = product_ids;

        if (this.id != 'new') {
            this.poolService.save(this.record)
            .subscribe(
                data => {
                    this.record = data.data;
                    this.draftsLookup(this.id);
                },
                error => {
                    this.handleError(error, this.poolForm);
                });
        } else {
            this.poolService.create(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record = data.data;
                    this.router.navigate(['/pools/' + data.data.id]);
                },
                error => {
                    this.handleError(error, this.poolForm);
                });
        }
    }
    
    nameChange() {
        if (this.id == 'new') {
            this.record.slug = this.string_to_slug(this.record.name);
        }
    }

    PreviewPage(draftslug:any, id: any, fullpath:any): void{

        console.log(draftslug);
        console.log(fullpath);
        console.log('/pagepreview/' + id + fullpath);

        const previewUrl = `/poolpreview/${id}${fullpath}`;
        window.open(previewUrl, '_blank');
        
    }

    editPage(id: number): void {

        this.draftsLookup(id);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/pools/' + id]);
        });
    }

    deletePage(id: any): void{
        const isConfirmed = window.confirm('Are you sure you want to delete this draft page?');

        if (isConfirmed) {
            this.poolService.draftdelete(id)
                .subscribe(
                    data => {
                        this.draftsLookup(this.id);
                    },
                    error => {
                        this.handleError(error, this.poolForm);
                    }
                );
        }
    }

    draftsave() {
        let product_ids =  this.record.related_products;
        
        this.record = this.poolForm.value;
        this.record.id = this.id;
        this.record.related_products = product_ids;

        if (this.id != 'new') {
            this.poolService.draftsave(this.record)
            .subscribe(
                data => {
                    this.record = data.data;
                    this.draftsLookup(this.id);
                    this.router.navigate(['/pools/' + data.data.id]);
                    this.draftsLookup(this.id);
                },
                error => {
                    this.handleError(error, this.poolForm);
                });
        } else {
            this.poolService.create(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record = data.data;
                    this.router.navigate(['/pools/' + data.data.id]);
                },
                error => {
                    this.handleError(error, this.poolForm);
                });
        }
    }

    draftsLookup(id: any){
        this.poolService.getRecord(id)
        .subscribe(
            data => {
                this.record = data.data;
                this.draftPages = this.record.draft_pages;
            },
            error => {
                this.record = {};
                this.handleError(error, this.poolForm);
            });
    }

    openPublishDialog(draftrecordId: any): void {

        const dialogRef = this.dialog.open(PublishDialogComponent, {
            width: '500px',
            data: { draftrecordId: draftrecordId, record: this.record }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const { selectedDate, selectedTime, publishNow, removeSchedule } = result;
            this.record = this.poolForm.value;
            this.record.id = this.id;

            if (removeSchedule) {
              this.poolService.removeSchedule(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Schedule removed successfully:', response);
                }, error => {
                  console.error('Error removing schedule:', error);
                });
            } else if (publishNow) {

              this.poolService.publishnow(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Publish now successful:', response);
                }, error => {
                  this.handleError(error, this.poolForm);
                });
            } else {
              this.poolService.publishschedule(this.record, selectedDate, selectedTime)
                .subscribe(response => {
                    this.draftsLookup(this.id);
                    console.log('Publish scheduled successfully:', response);
                }, error => {
                  console.error('Error scheduling publish:', error);
                });
            }
          } else {
            console.log('Dialog closed without result');
          }
        });
      }
}
